<div style='width:900px;overflow:hidden'>
  <div style='position:relative; top:0px; left:870px'>
    <i class='fa fa-times-circle fa-2x' (click)='close()'></i>
  </div>
  <div mat-dialog-title>
    Collect with Stripe
  </div>
  <div mat-dialog-content>
    Our relationship with the credit card processor Stripe (stripe.com) allows us to securely collect payments on your behalf and deposit them directly into your account. All you need to do is set up your own Stripe account and click the Connect with Stripe button on the group settings page. Once connected, you're all set! Golf GamesKeeper will collect a small application fee (0.1%) to cover platform costs.
  </div>
  <div mat-dialog-content style='margin-top:10px;'>
    The diagram below illustrates how this process works. We never store customer card information, and all transactions are visible directly on your Stripe dashboard.
  </div>
  <div mat-dialog-content>
    <img src='/assets/images/direct_charges.png' style='width:900px'>
  </div>
</div>